export default __webpack_public_path__ + "454f944b6a4061b0ac2932fc2ba2de17.svg";